import {createContext} from "react";

export const OrderViewContext = createContext(undefined);